import { useEffect, useState } from "react";

import EmptyState from "../components/EmptyState";
import LoadingState from "../components/LoadingState";
import PageTitle from "../components/PageTitle";
import { adminApi } from "../services/adminApi";
import { formatCurrency } from "../utils/formatters";

function OrderItems({ items }) {
  if (!items?.length) {
    return <EmptyState text="No items on this order." />;
  }

  return (
    <div className="admin-list">
      {items.map((item) => (
        <article key={item.id}>
          <strong>
            {item.quantity} x {item.item_name}
          </strong>
          <span>{formatCurrency(item.unit_price)} each</span>
          <span>{formatCurrency(item.line_total)}</span>
        </article>
      ))}
    </div>
  );
}

export default function OrderDetailsPage({ orderId }) {
  const [order, setOrder] = useState(null);
  const [internalNotes, setInternalNotes] = useState("");

  useEffect(() => {
    adminApi(`/orders/${orderId}/`).then((payload) => {
      setOrder(payload);
      setInternalNotes(payload.internal_notes || "");
    });
  }, [orderId]);

  const saveInternalNotes = async () => {
    const payload = await adminApi(`/orders/${orderId}/`, {
      method: "PATCH",
      body: JSON.stringify({ internal_notes: internalNotes }),
    });

    setOrder(payload);
  };

  if (!order) {
    return (
      <main className="admin-page">
        <LoadingState />
      </main>
    );
  }

  return (
    <main className="admin-page flex flex-column gap-5">
      <PageTitle eyebrow="Order Detail" title={order.order_number}>
        {order.customer_name} - {order.location_name}
      </PageTitle>

      <section className="grid-2">
        <section className="card admin-panel">
          <header className="card-header">
            <h2>Items</h2>
          </header>
          <div className="card-body">
            <OrderItems items={order.items} />
          </div>
        </section>

        <section className="card admin-panel">
          <header className="card-header">
            <h2>Customer & Notes</h2>
          </header>
          <div className="card-body flex flex-column gap-4">
            <p>{order.customer_email}</p>
            <p>{order.customer_phone}</p>

            <textarea
              className="form-textarea"
              value={internalNotes}
              onChange={(event) => setInternalNotes(event.target.value)}
            />

            <button className="btn btn-primary" onClick={saveInternalNotes}>
              Save Notes
            </button>
            <button className="btn btn-secondary" onClick={() => window.print()}>
              Print Ticket
            </button>
          </div>
        </section>
      </section>
    </main>
  );
}